import React from 'react';
import styles from './style.module.scss';

type Props = {text: string};

export const FeatureLabel = (props: Props) => {
    return <span className={styles.component}>{props.text}</span>;
};
